import React from 'react';
import { Divider, Grid, List, ListItem, ListItemSecondaryAction, ListItemText } from '@mui/material';
import { useNotifications } from '../../providers/Notifications';
import Loader from '../Loader/Loader';
import './Notifications.scss';
import { useTranslation } from 'react-i18next';

export default function Notifications() {
    const { t } = useTranslation();

    const NotificationsContext = useNotifications();

    const getDisplayNotification = (apiMessage, messageData) => {
        let replacement:any = [];
        let pattern = new RegExp(/{([^}]+)}/g);
        let controller;
        while(null != (controller=pattern.exec(apiMessage))) {   
            if(controller[1] in messageData) {
                replacement.push({ key:`${controller[0]}`, value: messageData[controller[1]] })
            }
        }
        let result = replacement.reduce((acc, val) => {
            if(val.value){
                return acc.replace(new RegExp(`${val.key}`, 'gi'), val.value)
            }   
            else return acc
        }, apiMessage);
            return result
    }
       

    return (
        NotificationsContext.loading? <Loader /> : (
            <Grid container item className='bg-white notifications'>
               
            <List>
                {
                (NotificationsContext?.notifications?.result && NotificationsContext?.notifications?.result?.length >= 1)? 
                    NotificationsContext?.notifications.result?.map( (item, index) => {  
                        return (  <span key={index}>
                            <ListItem >
                            <ListItemText  primary={<div dangerouslySetInnerHTML={{ __html: `${getDisplayNotification(item.message.description, item.message?.messagedata)}` }} /> } />
                            <ListItemSecondaryAction>
                                <a href={item.message.messagedata?.href} target={item.message.messagedata?.target}>
                                { 
                                (item.message.messagedata?.target === '_blank')? <i className='icon-external-link' /> : <i className='icon-chevron-thin-right' />
                                }
                                </a>
                            </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                        </span>)     
                    }) 
                    : <span className='no-new-notifications'>{t('home.no-new-notifications')}</span>
                }  
                
            </List>
            </Grid>
        )

    );
}
